export default "__VITE_ASSET__SVReix0y__"